import React from 'react';
import ReactDOM from 'react-dom';
import ErrorPage from '../components/ErrorPage';

export function setupGlobalErrorHandler() {
    console.log('Setting up global error handler...');
    window.addEventListener('error', function(event) {
        console.error('Global error caught:', event.error);
        // Optionally handle specific errors like ChunkLoadError
        if (event.error && event.error.toString().includes('ChunkLoadError')) {
            const rootElement = document.getElementById('root');
            if (rootElement) {
                // Ensure we don't accidentally clear the existing React root if it's still partially functional
                // A simple approach is to just replace the innerHTML, 
                // though using createRoot is cleaner if we are sure we want to take over.
                try {
                    ReactDOM.render(
                        <ErrorPage errorInfo={{ message: 'Failed to load critical application resources. Please refresh the page.' }} />,
                        rootElement
                    );
                    console.log('Rendered error page due to ChunkLoadError.');
                } catch (renderError) {
                    console.error('Failed to render error page:', renderError);
                    // Fallback if React rendering fails
                    rootElement.innerHTML = '<div style="padding: 20px; text-align: center;"><h1>Application Error</h1><p>Failed to load critical resources. Please refresh the page.</p></div>';
                }
            } else {
                console.error('Cannot render error page: #root element not found.');
            }
        }
        // Add handling for other critical global errors if necessary
    });

    window.addEventListener('unhandledrejection', function(event) {
        console.error('Unhandled promise rejection caught:', event.reason);
        // Optionally report this to an error tracking service
    });
    console.log('Global error handler set up.');
} 